import type { DocumentFileSavedNotice } from '../realtime/documentCollaborationTypes';

/** Normalize Entra ids / emails for case-insensitive comparison. */
export function normalizeIdentityKey(value: string): string {
  return value.trim().toLowerCase().replace(/[{}-]/g, '');
}

export interface IsDocumentSavedByCurrentUserOptions {
  /** Fallback when oid/upn aliases are not loaded yet. */
  displayName?: string | null;
}

/** Exact editor-session correlation, with identity fallback only for legacy notices. */
export function isDocumentSavedByEditorSession(
  notice: DocumentFileSavedNotice,
  editorSessionId: string | null | undefined,
  aliases: Iterable<string>,
  options?: IsDocumentSavedByCurrentUserOptions
): boolean {
  const noticeSessionId = notice.savedBySessionId?.trim();
  if (noticeSessionId) {
    const localSessionId = editorSessionId?.trim();
    return Boolean(localSessionId && localSessionId === noticeSessionId);
  }
  return isDocumentSavedByCurrentUser(notice, aliases, options);
}

/** True when the SignalR notice was raised by the current user (oid, mail, upn, etc.). */
export function isDocumentSavedByCurrentUser(
  notice: DocumentFileSavedNotice,
  aliases: Iterable<string>,
  options?: IsDocumentSavedByCurrentUserOptions
): boolean {
  const savedBy = notice.savedByUserId?.trim();
  if (savedBy) {
    const key = normalizeIdentityKey(savedBy);
    for (const alias of aliases) {
      const a = alias?.trim();
      if (a && normalizeIdentityKey(a) === key) return true;
    }
  }

  const savedName = notice.savedByDisplayName?.trim();
  const mine = options?.displayName?.trim();
  if (savedName && mine && savedName.toLowerCase() === mine.toLowerCase()) {
    return true;
  }

  return false;
}
